var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M502.025,76.385L306.731,262.778L504.09,433.112c4.958-7.159,7.91-15.821,7.91-25.173V104.058 C512,93.537,508.169,83.997,502.025,76.385z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.684,256.925l6.801,6.323c14.319,13.329,36.727,13.32,51.021,0.009L488.849,65.36 c-6.315-3.473-13.466-5.623-21.171-5.623H44.322c-9.199,0-17.749,2.825-24.841,7.637l204.16,189.525 C223.65,256.908,223.667,256.916,223.684,256.925z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.467,79.501C2.765,86.541,0,94.981,0,104.06v303.88c0,8.823,2.662,17.007,7.117,23.919l197.922-168.951L7.467,79.501z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.284,275.615l-0.068,0.06l-0.009,0.009l-0.077,0.068c-13.013,12.117-30.643,16.666-47.13,13.619 c-1.084-0.196-2.116-0.632-3.191-0.896c-2.176-0.538-4.378-1.015-6.485-1.826c-3.132-1.203-6.17-2.705-9.071-4.506 c-0.026-0.017-0.051-0.026-0.077-0.034c-2.927-1.818-5.709-3.942-8.32-6.366l-1.229-1.143L18.963,444.191 c7.194,5.052,15.915,8.073,25.361,8.073h423.347c8.909,0,17.169-2.688,24.124-7.228L294.342,274.634L293.284,275.615z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.f1605a72ba3fe7f0808d77645eb1177f.svg";
export { ForwardRef as ReactComponent };